import { Component, Input, Output } from "@angular/core";
import { Pager, PagerService } from "../../../services/pager/pager.service";
import { EventEmitter } from "@angular/core";
import { ReportService } from "src/app/services/report.service";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "pager",
  templateUrl: "pager-control.componen.html",
  styleUrls: ["./pager-control.component.css"],
  providers: [{ provide: PagerService, useClass: PagerService }],
})
export class PagerControlComponent {
  pager: Pager;
  @Input() exportColumns: any[] = [];
  @Input() exportColumnsName: any[] = [];
  @Input() onPage: boolean = false;
  @Input() info: string = "";
  private allItems: any[];
  private pagedItems: any[];
  allItemsCount: number;
  @Output() selectedPageIndexChange = new EventEmitter();
  @Input() selectedAmount: number | null = null;

  constructor(
    private pagerService: PagerService,
    private reportService: ReportService
  ) {
    this.allItemsCount = 0;
    this.pager = new Pager();
  }

  public setItems(allItems: any[]) {
    this.allItems = allItems;
    if (allItems) {
      this.allItemsCount = allItems.length;
    }
    // get pager object from service
    this.setPage(1);
  }

  setPage(page: number) {
    if (!this.onPage) {
      this.pager = this.pagerService.getPager(this.allItems.length, page);
      // get current page of items
      this.pagedItems = this.allItems.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    } else {
      this.pager = this.pagerService.getPager(
        this.allItems.length,
        page,
        this.allItems.length
      );
      this.pagedItems = this.allItems;
    }

    this.selectedPageIndexChange.emit(this.pagedItems);
  }

  getAllItems(): any[] {
    return this.allItems;
  }

  async exportToCsv() {
    if (!this.allItems || this.allItems.length === 0) return;

    await this.reportService.downloadExcel(
      this.allItems,
      this.exportColumns,
      this.exportColumnsName
    );
  }
}
